import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch } from 'react-router-dom';
import { matchPath } from 'react-router';
import { get } from 'lodash';

import PageLayout from '../layouts/PageLayout';
import { pages } from '../constants/routes';

// Main Container/jsx Displayed on the page
const CustomersContainer = Loadable({
  loader: () => import('../containers/customers'),
  loading: () => null,
});

export default function (store: any, props: any) {
    // call Register Reducer here
  const match = props.match;
  const customerPageParameters: any = matchPath(match.url, {
    exact: true,
    path: pages.customer(':email', ':tab'),
    strict: false,
  });

  const renderFunction = (props: any) => {
    const more = {
      ...props,
      customerEmail: get(customerPageParameters, 'params.email'),
      tab: get(customerPageParameters, 'params.tab', 'details'),
    };
    return <CustomersContainer {...more} />;
  };

  return (
    <Switch>
      <PageLayout>
          <Route
            path={ match.url }
            render={ renderFunction }
          />
      </PageLayout>
    </Switch>
  );
}
